import { requestWrapper } from '@/utils/axiosInstance';

export default {
  async getAll(query) {
    return await requestWrapper(null, 'GET', `/features`, query);
  },
  async create(feature) {
    return await requestWrapper(null, 'POST', '/features', null, feature);
  },
  async get(id) {
    return await requestWrapper(null, 'GET', `/features/${id}`);
  },
  async update(feature) {
    return await requestWrapper(null, 'PUT', `/features/${feature.id}`, null, feature);
  },
  async remove(id) {
    return await requestWrapper(null, 'DELETE', `/features/${id}`);
  },
  async getUnits() {
    return await requestWrapper(null, 'GET', `/measure_units`);
  },
};
